<template>
  <nav class="navbar navbar-expand-md navbar-light navbar-laravel">
    <div class="navbar-style">
      <div class="container">
        <img
          class="navbar-logo"
          src="@/assets/navBarLogo.png"/>
        <div
          id="navbarSupportedContent"
          class="collapse navbar-collapse"
        >
          <ul class="navbar-nav mr-auto" />
          <ul class="navbar-nav ml-auto">

            <template v-if="user.loggedIn">
              <div class="menu">
                  <router-link
                    v-for="(item, index) in menuItems"
                    :key="index"
                    :to="item.to"
                    
                  >
                    <div class="menu-item">
                      <img class="navbar-ItemImage" :src="require(`@/assets/${item.image}`)"/>
                      <div class="navbar-ItemText" :class="$route.path==item.to?'active':undefined"> {{ item.title }}</div> 
                    </div>
                  </router-link>
                
              </div>
              <div class="footer">
                 <div class="navbar-custom-headline">
                   Willkommen, {{ user.data.email }}!
                 </div>

                 

                <div class="footerButtons">
                <router-link to="/resetpassword">
                    Passwort ändern
                </router-link>
                </div>
                <div
                   to="login"
                   class="footerButtons"
                    active-class="active"
                    exact
                   @click.prevent="signOut" >
                  Sign out
                </div>
                <div class = "impressum">
                  <div class="impressumItems">Impressum</div>
                  <div class="impressumItems">Nutzungsbedingungen</div>
                </div>
              </div>
            </template>
            <template v-else>
              <!--                        We won't show any menu items when the use is not logged in. Instead we only show the login component-->
            </template>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
    import {mapGetters} from "vuex";
    import firebase from "firebase";

    export default {
        data(){
            return {
                
                menuItems: [],
                retailerItems: [
                    { title: "Dashboard", to:"/dashboard", image: "dashboard.png"},
                    { title: "Meine Artikel", to:"/myarticlesretailer", image: "myArticle.png"},
                    { title: "Verfügbare Artikel hochladen", to:"/csvuplad", image: "dashboard.png"}
                ],
                manufacturerItems: [
                    { title: "Dashboard", to:"/dashboard", image: "dashboard.png"},
                    { title: "Meine Artikel", to:"/myarticlesmanufacturer", image: "myArticle.png"},
                    { title: "Artikel hochladen", to:"/articleupload", image: "addArticle.png"},
                    { title: "Statistiken", to:"/statistics", image: "statistics.png"}
                ],
                userItems: [
                    { title: "No usage", to: "/wrong-scope", image: "dashboard.png" }
                ],
                adminItems: [
                    { title: "Retailers", to:"/dashboard", image: "dashboard.png"},
                    { title: "Manufecturers", to: "/myarticlesmanufacturer", image: "dashboard.png"},
                    { title: "Nutzungsrechte", to: "/articleupload", image: "dashboard.png"},
                    { title: "Statistics", to:"/statistics", image: "dashboard.png"} 
                ]
            }
        },
        computed: {
            ...mapGetters(['user'])
        },
        created() {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    this.$router.replace({
                        name: "Dashboard"
                    });
                  firebase.auth().currentUser.getIdTokenResult()
                          .then((idTokenResult) => {
                            // set user type based on our custom claims
                            if (idTokenResult.claims.admin) {
                              this.menuItems = this.adminItems
                            } else if (idTokenResult.claims.manufacturer) {
                              this.menuItems = this.manufacturerItems;
                            } else if (idTokenResult.claims.retailer) {
                              this.menuItems = this.retailerItems
                            } else {
                              // TODO route to default user screen
                            }
                          })
                          .catch((error) => {
                            console.log(error);
                          });
                } else {
                    this.$router.replace({
                        name: "login"
                    });
                }
            });
        },
        methods: {
            signOut() {
                firebase
                    .auth()
                    .signOut()
                    .then(() => {
                        this.$router.replace({
                            name: "login"
                        });
                    });
            }
        }
    };
</script>

<style scoped>
  .active{
    color: orange;
  }
  .navbar-style
  {
    color: white;
    height: 100%;
    width: 250px;
    position: fixed;
    float: left;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: #FFFFFF;
    padding-top: 20px;
    overflow-x: hidden;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    display: flex;
    flex-wrap: wrap;
  }
  
  .navbar-logo
  {
    margin-left: 20px;
    margin-top: 10px;
  }
  .menu
  {
    padding-top: 30px;
    background-color: #ffffff;
    font-family: 'Exo', sans-serif;
    padding-left: 0px;
    margin-left: -20px;
    
    }
  .menu-item
  {
    height: 45px;
    width: 100%;
    margin-bottom: 8px;
    color: #353736;
  } 
  .navbar-ItemImage
  {
  width: 21px;
  height: 21px;
  display: block;
  float: left;
  }
.navbar-ItemText
  {
  padding-left: 20px;
  font-family: 'Exo', sans-serif;
  font-size: 16px;
  font-weight: bold;
  display: block;
  float: left;
  
  }
.menu-item-selected
  {
    background-color: #BABABA;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-left: 0px;
    color: #F88623;
  }
.footer 
{
  position: fixed; 
  left: 0px;
  bottom: 0px; 
  height: 180px;
  width: 250px ; 
  background-image:linear-gradient(400deg, #ff7600, #fa9842);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.navbar-custom-headline{
    color:#ffffff;
    text-align: left;
    font-family: 'Exo', sans-serif;
    padding-left: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
    font-size: 14px;
    font-weight: bold;
  }
.footerButtons
  {
    color:#ffffff;
    text-align: left;
    font-family: 'Exo', sans-serif;
    padding-left: 20px;
    padding-bottom: 6px;
    font-size: 12px;
  }
.impressum
{
  padding: 20px;
}
.impressumItems
{
  font-size: 8px;
  color:#ffffff;
  display: block;
  float: left;
  width: 50%;
}


</style>